<template>
  <div class="section-item books">
    <!-- Discount Badge (commented out - uncomment if needed) -->
    <!-- <div v-if="item.discount > 0" class="discount-badge">
      <span>{{ item.discount }}</span>
      <span v-if="item.discount_type == 'Percent'">%</span>
      <span v-else class="taka-off">Tk.</span>
      <div>OFF</div>
    </div> -->

    <a :href="`${baseUrl}book/${item.id}`">
      <vue-load-image>
        <img
          slot="image"
          :src="`${IMAGEURL}${item.image}`"
          alt=""
          class="img-responsive"
        />
        <img
          slot="preloader"
          :src="`${IMAGEURL}/assets/img/loader.gif`"
          title="Image Loading..."
        />
        <div slot="error">can't load image</div>
      </vue-load-image>

      <h4 v-if="item.award_title" class="award-title">
        {{ item.award_title }}
      </h4>

      <h4 v-if="item.product_name.length < truncateAt">
        {{ item.product_name }}
      </h4>
      <h4
        v-if="item.product_name.length >= truncateAt"
        :title="item.product_name"
      >
        {{ item.product_name.substr(0, truncateAt) + "..." }}
      </h4>
    </a>

    <div class="item-price">
      <span v-if="item.discount > 0"><strike>Tk. {{ Math.floor(item.orginal_price) }}</strike>&nbsp;&nbsp;</span>
      <span>Tk. {{ Math.floor(item.price) }}</span>
    </div>

    <div :class="hoverClass">
      <div class="arrow-up"></div>
      <a
        v-if="item.quantity > 0"
        href="javascript:;"
        @click="onAddToCart"
        :class="['btn', 'btn-primary', 'add-to-cart', btnClass]"
      >Add to Cart</a>
      <a
        v-else
        href="javascript:;"
        :class="['btn', 'btn-primary', 'add-to-cart', 'disabled', btnClass]"
      >Out of Stock</a>
      <a
        :href="`${baseUrl}book/${item.id}`"
        :class="['btn', 'btn-black', 'view-details', btnClass]"
      >View Details</a>
    </div>
  </div>
</template>

<script>
import VueLoadImage from "vue-load-image";

export default {
  name: "BookCard",
  components: {
    VueLoadImage
  },
  props: {
    item: {
      type: Object,
      required: true
    },
    truncateAt: {
      type: Number,
      default: 14
    },
    hoverClass: {
      type: String,
      default: "hover-item"
    },
    btnClass: {
      type: String,
      default: ""
    }
  },
  methods: {
    onAddToCart() {
      this.$emit("add-to-cart", this.item);
    }
  }
};
</script>
